(function () {
  const SAFE_KEYS = new Set([
    'productHandle',
    'collectionHandle',
    'mode',
    'surface',
    'cta',
    'path',
    'pageHandle',
    'template',
    'context',
    'hasValue',
    'nameLength',
    'isValid',
    'inputType',
  ]);

  function normalizeValue(value) {
    if (value === null || value === undefined) return null;
    if (typeof value === 'boolean' || typeof value === 'number') return value;

    const text = String(value).trim();
    return text.length > 0 ? text : null;
  }

  function sanitizeDetail(detail) {
    const sanitized = {};

    Object.entries(detail || {}).forEach(([key, value]) => {
      if (!SAFE_KEYS.has(key)) return;

      const normalized = normalizeValue(value);
      if (normalized === null) return;

      sanitized[key] = normalized;
    });

    return sanitized;
  }

  function collectDatasetDetail(element) {
    if (!element) return {};

    return sanitizeDetail({
      productHandle: element.dataset.murmleProductHandle,
      collectionHandle: element.dataset.murmleCollectionHandle,
      mode: element.dataset.murmleMode,
      surface: element.dataset.murmleSurface,
      cta: element.dataset.murmleCta,
      path: element.dataset.murmlePath,
      pageHandle: element.dataset.murmlePageHandle,
      template: element.dataset.murmleTemplate,
      context: element.dataset.murmleContext,
      inputType: element.dataset.murmleInputType,
    });
  }

  function track(eventName, detail = {}) {
    if (!eventName) return;

    const payload = sanitizeDetail(detail);
    const eventPayload = {
      event: `murmle_${eventName}`,
      ...payload,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventPayload);

    document.dispatchEvent(
      new CustomEvent('murmle:analytics', {
        detail: {
          name: eventName,
          payload,
        },
      })
    );
  }

  window.MurmleAnalytics = {
    track,
  };

  document.addEventListener('click', (event) => {
    const actionElement = event.target.closest('[data-murmle-event]');
    if (!actionElement) return;

    track(actionElement.dataset.murmleEvent, collectDatasetDetail(actionElement));
  });

  const seenViews = new Set();

  function trackView(element) {
    const eventName = element.dataset.murmleView;
    if (!eventName) return;

    const dedupeKey = [
      eventName,
      element.dataset.murmlePageHandle,
      element.dataset.murmleProductHandle,
      element.dataset.murmleCollectionHandle,
      element.dataset.murmleSurface,
      element.id,
    ]
      .filter(Boolean)
      .join(':');

    if (seenViews.has(dedupeKey)) return;
    seenViews.add(dedupeKey);

    track(eventName, collectDatasetDetail(element));
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          trackView(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.45 }
    );

    document.querySelectorAll('[data-murmle-view]').forEach((element) => observer.observe(element));
  } else {
    document.querySelectorAll('[data-murmle-view]').forEach((element) => trackView(element));
  }

  document.addEventListener('murmle:personalization-started', (event) => {
    track('personalization_started', event.detail);
  });
})();
